<div class="w-full flex align-items-center justify-content-center bg-center bg-cover border-bottom-1 border-primary"
    style="background: linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #36DEFB 100%); min-height: 16rem;">
    <div class="flex flex-column justify-content-center align-items-center text-center px-4 py-6">
        <h1 class="text-white text-4xl md:text-5xl lg:text-6xl font-bold mb-3">Privacy Policy</h1>
        <p class="text-gray-300 text-lg m-0">How ESZES handles personal data on eszes.in and in the free local edition</p>
    </div>
</div>

<section class="bg-white py-6 md:py-8" data-prerender>
    <div class="px-4 md:px-6 lg:px-8">
        <div class="legal">
            <p class="meta">Last updated: 17 September 2026 · Applies to the website <strong>eszes.in</strong> and the Snapcart free local edition.
                Hosted BMS services are covered by the separate agreement each customer signs.</p>

            <h2>1. Who we are</h2>
            <p><strong>ESZES Consultancy &amp; Services</strong><br>Plot No. 36, Karuna, Pushpavihar, Nadathara, Thrissur 680751, Kerala, India<br>
                E-mail: <a href="mailto:info&#64;eszes.in">info&#64;eszes.in</a> · Phone: <a href="tel:+919895013318">+91 98950 13318</a></p>
            <p>We are the data fiduciary (controller) for the personal data described in this policy. Our processing of
                personal data of individuals in India is governed by the Digital Personal Data Protection Act, 2023 and the
                Information Technology Act, 2000.</p>

            <h2>2. What we collect, and why</h2>
            <table>
                <thead><tr><th>When</th><th>Data</th><th>Purpose and legal basis</th></tr></thead>
                <tbody>
                    <tr><td>You use the contact form</td><td>Name, e-mail address, company (optional), the topic you pick and your message</td>
                        <td>To answer your enquiry. Consent, given when you submit the form.</td></tr>
                    <tr><td>You request access to the Snapcart free local edition</td><td>The above plus your operating system and the MAC address of the computer the licence is for</td>
                        <td>To issue a licence file bound to that machine and create your sign-in account. Consent; the MAC address is used for nothing else.</td></tr>
                    <tr><td>You subscribe to the newsletter in the footer</td><td>E-mail address</td>
                        <td>To send occasional news about BMS and the free edition. Consent; withdraw it any time by replying "unsubscribe" or writing to info&#64;eszes.in.</td></tr>
                    <tr><td>You sign in to the free local edition</td><td>E-mail address, name and the sign-in events Amazon Cognito records</td>
                        <td>To authenticate you and keep the account secure. Performance of the licence terms.</td></tr>
                    <tr><td>You visit any page</td><td>Standard server logs: IP address, browser type, pages requested, time</td>
                        <td>To serve the site, keep it secure and diagnose faults. Our legitimate interest in running a secure site. Logs are kept for a limited period and not used to profile you.</td></tr>
                </tbody>
            </table>
            <p>We do not sell personal data, and we do not use it for advertising.</p>

            <h2>3. Cookies and local storage</h2>
            <p>eszes.in sets no advertising or analytics cookies. The site stores nothing about you in your browser beyond what
                the browser itself caches to load pages faster. Third-party content on the site may set its own cookies
                or receive your IP address when it loads; see section 5.</p>

            <h2>4. Where your data is stored</h2>
            <p>Form submissions are stored in our content management service on Amazon Web Services in the Mumbai region
                (ap-south-1). Free-edition sign-in accounts are held in Amazon Cognito in the same region. Data you create
                inside the free local edition stays on your own computer; only sign-in touches our servers.</p>

            <h2>5. Third parties that receive data</h2>
            <ul>
                <li><strong>Amazon Web Services</strong> (hosting, storage, e-mail and sign-in) — processor under our instructions.</li>
                <li><strong>Google Maps</strong> embed on the contact page — Google receives your IP address and may set cookies when the map loads. See <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">Google's privacy policy</a>.</li>
                <li><strong>Google Fonts and unpkg (jsDelivr/Cloudflare CDN)</strong> — the web fonts and the animation player are fetched from these networks, which receive your IP address as part of the request.</li>
            </ul>
            <p>We share personal data with no one else unless the law requires it.</p>

            <h2>6. How long we keep it</h2>
            <ul>
                <li>Enquiries and access requests: up to 24 months after our last exchange, so we can follow up and keep a record of licences issued.</li>
                <li>Free-edition accounts: for as long as the licence is valid, then deleted on request or after 12 months of inactivity.</li>
                <li>Server logs: up to 90 days.</li>
            </ul>

            <h2>7. Your rights</h2>
            <p>You can ask us to show you the personal data we hold about you, correct it, delete it, or withdraw consent you
                have given. Withdrawing consent for an access request means we can no longer issue or renew a free-edition
                licence for you. Write to <a href="mailto:info&#64;eszes.in">info&#64;eszes.in</a>; we respond within 30 days.
                If you are not satisfied, you may complain to the Data Protection Board of India.</p>

            <h2>8. Security</h2>
            <p>Data is transmitted over HTTPS, stored in access-controlled AWS accounts, and every change to a record in our
                systems is audited. No method of transmission or storage is completely secure; if a breach affecting your
                data occurs we will notify you as the law requires.</p>

            <h2>9. Children</h2>
            <p>The site and the free local edition are intended for businesses and adults. We do not knowingly collect
                personal data from anyone under 18.</p>

            <h2>10. Changes</h2>
            <p>We may update this policy; the date at the top shows the current version. Material changes will be announced
                on this page.</p>

            <h2>11. Contact</h2>
            <p><strong>ESZES Consultancy &amp; Services</strong><br>Plot No. 36, Karuna, Pushpavihar, Nadathara, Thrissur 680751, Kerala, India<br>
                E-mail: <a href="mailto:info&#64;eszes.in">info&#64;eszes.in</a> · Phone: <a href="tel:+919895013318">+91 98950 13318</a></p>
        </div>
    </div>
</section>
